import React, { useContext, useEffect, useState } from 'react';
import './Doc.css';
import { FirebaseContext } from '../../context/firebase';
import Lots from './lots/Lots';
import ModelHomes from './modelHomes/ModelHomes';
import Pricing from './pricing/Pricing';
import StepBar from './StepBar';
import { useLocation } from 'react-router';
import { useStep } from 'react-hooks-helper';
import Dates from './dates/Dates';
import Client from './client/Client';
import Lawyer from './lawyer/Lawyer';
import Finances from './finances/Finances';
import Spinner from '../layout/spinner/Spinner';
import { Box, CircularProgress, Typography } from '@material-ui/core';

import * as PROJECT_CODE from '../../constants/projectCode';

function Doc() {
  const { firebase } = useContext(FirebaseContext);
  const [lotList, setLotList] = useState('');
  const [elevationList, setElevationList] = useState([]);
  const [exteriorImage, setExteriorImage] = useState();
  const [pricingDetails, setPricingDetails] = useState([]);
  const [elevationPriceSum, setElevationPriceSum] = useState();
  const [buildingPriceSum, setBuildingPriceSum] = useState();
  const [lotPriceSum, setLotPriceSum] = useState();
  const [elevationPrice, setElevationPrice] = useState(0);
  const [elevationId, setElevationId] = useState();
  const [floorplan, setFloorplan] = useState();
  const [lotPrice, setLotPrice] = useState(0);
  const [totalUpgradePrice, setTotalUpgradePrice] = useState();
  const [irrevocableDate, setIrrevocableDate] = useState();
  const [closingDate, setClosingDate] = useState();
  const [individualDetails, setIndividualDetails] = useState();
  const [corporationDetails, setCorporationDetails] = useState();
  const [elevationTab, setElevationTab] = useState(0);
  const [lawyerDetails, setLawyerDetails] = useState();
  const [mortgageDetails, setMortgageDetails] = useState();
  const [totalMainFloor, setTotalMainFloor] = useState(0);
  const [expanded, setExpanded] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isCompleted, setIsCompleted] = useState({
    lots: false,
    modelhomes: false,
    pricing: false,
    // dates: false,
    client: false,
    // lawyer: false,
    // finances: false,
  });
  const [disable, setDisable] = useState({
    lots: true,
    modelhomes: true,
    pricing: true,
    // dates: true,
    client: true,
    // lawyer: true,
    // finances: true,
  });
  const [upgradeTotalPrice, setUpgradeTotalPrice] = useState({
    cabinetry: 0,
    countertops: 0,
    doorstrim: 0,
    flooring: 0,
    lighting: 0,
    plumbing: 0,
  });
  const [displayFinal, setDisplayFinal] = useState({
    lots: false,
    modelhomes: false,
    pricing: false,
    // dates: false,
    client: false,
    // lawyer: false,
    // finances: false,
  });
  const [premiumDescription, setPremiumDescription] = useState();

  useEffect(() => {
    var currentUserId = firebase.auth().currentUser.uid;
    firebase
      .database()
      .ref('/users/' + currentUserId + '/document')
      .once('value', (snapshot) => {
        var expandedData = snapshot.val()?.expanded;
        if (expandedData === 0) {
          navigation.go(0);
        } else if (expandedData === 1) {
          navigation.go(1);
        } else if (expandedData === 2) {
          navigation.go(2);
        } else if (expandedData === 3) {
          navigation.go(3);
        }
        // else if (expandedData === 4) {
        // 	navigation.go(4);
        // } else if (expandedData === 5) {
        // 	navigation.go(5);
        // } else if (expandedData === 6) {
        // 	navigation.go(6);
        // }
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    var currentUserId = firebase.auth().currentUser.uid;
    // console.log('App CODe: ' + location.state.clientAppCode);
    firebase
      .database()
      .ref('/users/' + currentUserId + '/document/documentInformation')
      .once('value', (snapshot) => {
        var isCompletedData = snapshot.val()?.isCompleted;
        var disableData = snapshot.val()?.disable;
        var expandedData = snapshot.val()?.expanded;
        var lotListData = snapshot.val()?.lotList;
        var elevationListData = snapshot.val()?.elevationList;
        var exteriorImageData = snapshot.val()?.exteriorImage;
        var pricingDetailsData = snapshot.val()?.pricingDetails;
        var totalMainFloorData = snapshot.val()?.totalMainFloor;
        var elevationTabData = snapshot.val()?.elevationTab;
        var displayFinalData = snapshot.val()?.displayFinal;
        var elevationPriceSumData = snapshot.val()?.elevationPriceSum;
        var buildingPriceSumData = snapshot.val()?.buildingPriceSum;
        var lotPriceSumData = snapshot.val()?.lotPriceSum;
        var elevationPriceData = snapshot.val()?.elevationPrice;
        var elevationIdData = snapshot.val()?.elevationId;
        var lotPriceData = snapshot.val()?.lotPrice;
        var totalUpgradePriceData = snapshot.val()?.totalUpgradePrice;
        var irrevocableDateData = snapshot.val()?.irrevocableDate;
        var closingDateData = snapshot.val()?.closingDate;
        var individualDetailsData = snapshot.val()?.individualDetails;
        var corporationDetailsData = snapshot.val()?.corporationDetails;
        var lawyerDetailsData = snapshot.val()?.lawyerDetails;
        var mortgageDetailsData = snapshot.val()?.mortgageDetails;
        console.log('irrevocableDate' + irrevocableDateData);
        console.log('closing' + closingDateData);
        if (
          isCompletedData !== undefined ||
          disableData !== undefined ||
          expandedData !== undefined ||
          lotListData !== undefined ||
          elevationListData !== undefined ||
          exteriorImageData !== undefined ||
          pricingDetailsData !== undefined ||
          totalMainFloorData !== undefined ||
          displayFinalData !== undefined ||
          elevationPriceSumData !== undefined ||
          elevationTabData !== undefined ||
          buildingPriceSumData !== undefined ||
          lotPriceSumData !== undefined ||
          elevationPriceData !== undefined ||
          elevationIdData !== undefined ||
          lotPriceData !== undefined ||
          totalUpgradePriceData !== undefined ||
          irrevocableDateData !== undefined ||
          closingDateData !== undefined ||
          individualDetailsData !== undefined ||
          corporationDetailsData !== undefined ||
          lawyerDetailsData !== undefined ||
          mortgageDetailsData !== undefined
        ) {
          console.log('expanded: ' + expandedData);
          setIsCompleted(isCompletedData);
          setDisable(disableData);
          setExpanded(expandedData);
          setLotList(lotListData);
          setElevationList(elevationListData);
          setPricingDetails(pricingDetailsData);
          setExteriorImage(exteriorImageData);
          setElevationTab(elevationTabData);
          setTotalMainFloor(totalMainFloor);
          setDisplayFinal(displayFinalData);
          setElevationPriceSum(elevationPriceSumData);
          setBuildingPriceSum(buildingPriceSumData);
          setLotPriceSum(lotPriceSumData);
          setElevationPrice(elevationPriceData);
          setElevationId(elevationIdData);
          setLotPrice(lotPriceData);
          setTotalUpgradePrice(totalUpgradePriceData);
          setIrrevocableDate(irrevocableDateData);
          setClosingDate(closingDateData);
          setIndividualDetails(individualDetailsData);
          setCorporationDetails(corporationDetailsData);
          setLawyerDetails(lawyerDetailsData);
          setMortgageDetails(mortgageDetailsData);
          setLoading(false);
        } else {
          setLoading(false);
        }
      });
  }, []);

  // multi step form
  const steps = [
    { id: 'lots' },
    { id: 'modelhomes' },
    { id: 'pricing' },
    // { id: 'dates' },
    { id: 'client' },
    // { id: 'lawyer' },
    // { id: 'finances' },
  ];

  const { step, navigation } = useStep({
    steps,
    initialStep: 0,
  });

  const switchComponent = () => {
    console.log('Expanded: ' + expanded);
    switch (step.id) {
      case 'lots':
        return (
          <Lots
            setLotList={setLotList}
            setBuildingPriceSum={setBuildingPriceSum}
            setLotPriceSum={setLotPriceSum}
            setLotPrice={setLotPrice}
            setIsCompleted={setIsCompleted}
          />
        );

      case 'modelhomes':
        return (
          <ModelHomes
            setLotList={setLotList}
            elevationList={elevationList}
            lotList={lotList}
            exteriorImage={exteriorImage}
            setExteriorImage={setExteriorImage}
            pricingDetails={pricingDetails}
            elevationPriceSum={elevationPriceSum}
            setBuildingPriceSum={setBuildingPriceSum}
            buildingPriceSum={buildingPriceSum}
            setLotPriceSum={setLotPriceSum}
            setElevationPrice={setElevationPrice}
            elevationPrice={elevationPrice}
            setElevationId={setElevationId}
            elevationId={elevationId}
            setLotPrice={setLotPrice}
            lotPrice={lotPrice}
            isCompleted={isCompleted}
            setIsCompleted={setIsCompleted}
            setDisable={setDisable}
            disable={disable}
            floorplan={floorplan}
            setFloorplan={setFloorplan}
            setTotalMainFloor={setTotalMainFloor}
            totalMainFloor={totalMainFloor}
            setElevationTab={setElevationTab}
            elevationTab={elevationTab}
          />
        );

      case 'pricing':
        return (
          <Pricing
            setTotalUpgradePrice={setTotalUpgradePrice}
            setIsCompleted={setIsCompleted}
            setUpgradeTotalPrice={setUpgradeTotalPrice}
            upgradeTotalPrice={upgradeTotalPrice}
          />
        );
      // case 'dates':
      // 	return (
      // 		<Dates
      // 			irrevocableDate={irrevocableDate}
      // 			setIrrevocableDate={setIrrevocableDate}
      // 			closingDate={closingDate}
      // 			setClosingDate={setClosingDate}
      // 			setIsCompleted={setIsCompleted}
      // 			setDisable={setDisable}
      // 			disable={disable}
      // 		/>
      // 	);
      case 'client':
        return (
          <Client
            setIndividualDetails={setIndividualDetails}
            setCorporationDetails={setCorporationDetails}
            setIsCompleted={setIsCompleted}
            setDisable={setDisable}
            disable={disable}
            isCompleted={isCompleted}
          />
        );
      // case 'lawyer':
      // 	return (
      // 		<Lawyer
      // 			setLawyerDetails={setLawyerDetails}
      // 			setIsCompleted={setIsCompleted}
      // 		/>
      // 	);
      // case 'finances':
      // 	return (
      // 		<Finances
      // 			irrevocableDate={irrevocableDate}
      // 			setMortgageDetails={setMortgageDetails}
      // 			setIsCompleted={setIsCompleted}
      // 			isCompleted={isCompleted}
      // 			elevationList={elevationList}
      // 			elevationPrice={elevationPrice}
      // 			lotPrice={lotPrice}
      // 			upgradeTotalPrice={upgradeTotalPrice}
      // 		/>
      // 	);

      default:
        break;
    }
  };

  const location = useLocation();

  return (
    <>
      {loading && (
        <div className='loading_layout'>
          <CircularProgress
            style={{ position: 'absolute', left: '50%', top: '15%' }}
          />
        </div>
      )}
      <div className='doc-page'>
        <div className='doc-page-header'>
          <div className='page-title'>
            <h1>Purchase Agreement</h1>
          </div>
        </div>
        <div className='flex-wrapper'>
          <div className='doc_flow_actions doc_card'>
            <StepBar
              lotList={lotList}
              setElevationList={setElevationList}
              elevationList={elevationList}
              setPricingDetails={setPricingDetails}
              setElevationPriceSum={setElevationPriceSum}
              exteriorImage={exteriorImage}
              setExteriorImage={setExteriorImage}
              elevationPriceSum={elevationPriceSum}
              navigation={navigation}
              buildingPriceSum={buildingPriceSum}
              setBuildingPriceSum={setBuildingPriceSum}
              setLotPriceSum={setLotPriceSum}
              lotPriceSum={lotPriceSum}
              elevationPrice={elevationPrice}
              elevationId={elevationId}
              lotPrice={lotPrice}
              pricingDetails={pricingDetails}
              totalUpgradePrice={totalUpgradePrice}
              irrevocableDate={irrevocableDate}
              closingDate={closingDate}
              individualDetails={individualDetails}
              corporationDetails={corporationDetails}
              lawyerDetails={lawyerDetails}
              mortgageDetails={mortgageDetails}
              setExpanded={setExpanded}
              expanded={expanded}
              setIsCompleted={setIsCompleted}
              isCompleted={isCompleted}
              setDisable={setDisable}
              disable={disable}
              setLoading={setLoading}
              loading={loading}
              upgradeTotalPrice={upgradeTotalPrice}
              displayFinal={displayFinal}
              setDisplayFinal={setDisplayFinal}
              setElevationId={setElevationId}
              floorplan={floorplan}
              totalMainFloor={totalMainFloor}
              setElevationTab={setElevationTab}
              elevationTab={elevationTab}
            />
          </div>
          <div className='application_wrapper'>
            <div className='doc-page-client-name'>
              <div className='header_client_name'>
                {/* {location.state.clientFName} */}
              </div>
              <div className='header_client_action'>
                <button>Client</button>
              </div>
            </div>
            {switchComponent()}
          </div>
        </div>
      </div>
    </>
  );
}

export default Doc;
